<template>
  <modal name="invoice-details-modal"
         @closed="$emit('updateComparisonData')"
         @before-open="beforeOpen"
         @before-close="beforeClose"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Դուրս գրել հաշիվ ապրանքագիր</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('invoice-details-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <div class="row">
        <div class="form-group col-md-6">
          <div class="mb-3 pl-1">
            <label for="address">Ֆակտուրայի համար</label>
            <input 
              v-model="$v.orderData.invoice_number.$model"
              :mask="'#################'"
              name="code"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="form-group col-md-6">
          <div class="mb-3 pl-1">
            <label for="address">Դուրս գրման ամսաթիվ</label>
            <input 
              v-model="$v.orderData.discharge_date.$model"
              v-mask="'##.##.####'"
              placeholder="Օր.Ամիս.Տարի"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="form-group col-md-6">
          <div class="mb-3 pl-1">
            <label for="address">Գնման առարկայի մակատարման ժամկետը փաստացի</label>
            <input
              v-model="$v.orderData.completion_actual_date.$model"
              v-mask="'##.##.####'"
              placeholder="Օր.Ամիս.Տարի"
              type="text"
              class="form-control"
            >
          </div>
        </div>
      </div>
    </div>
    <div id="modal-footer" class="bg-white w-100 p-3 text-center">
      <button @click="save" type="button" class="btn btn-primary waves-effect waves-light float-center mr-3" data-toggle="modal" data-animation="bounce">
          Պահպանել
      </button>
    </div>
  </modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'InvoiceDetailsModal',
  components: {  },
  data () {
    return {
      orderData: {
        invoice_number: '',
        discharge_date: '',
        completion_actual_date: '',
      },
    }
  },
  computed: {},
  validations() {
    return {
      orderData: {
        invoice_number: {required},
        discharge_date: {required},
        completion_actual_date: {required},
      },
    }
  },
  methods: {
    consoleLog(data){
      console.log(data)
    },
    async save(){
      if(!this.$v.orderData.$invalid) {
        console.log(this.order.contract)
        if(this.order.contract.from_application){
          this.orderData.status = 'completed'
        }
        await this.$client.put(`contract-orders/${this.order.id}`, this.orderData).then(({data}) => {
          if(data) {
            this.resetComponent()
            this.$modal.hide('invoice-details-modal')
            if(this.order.contract.from_application){
              this.$router.push('/contract-management/orders/finished')
            }
          }
        }).catch(e => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Ինչ որ բան այն չէ',
            text: 'Կրկին փորձեք!'
          })
        })
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'Լրացրեք բոլոր դաշտերը պահպանելու համար!'
        })
      }
    },
    formatDate(date) {
        var d = new Date(date);
        var month = '' + (d.getMonth() + 1);
        var day = '' + d.getDate();
        var year = d.getFullYear();
        console.log(d)

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
    },
    beforeOpen({params}) {
      this.resetComponent = params.resetComponent
      this.order = params.order
      // this.orderData = params.order

      // console.log(params)
      
      // console.log('moment', moment(this.order.discharge_date).format("YYYY-MM-DD"))
      // console.log(this.order.discharge_date)
      // console.log(this.formatDate(this.order.discharge_date))
      // this.orderData.invoice_number = this.order.invoice_number ? this.order.invoice_number : "";
      // this.orderData.discharge_date = this.order.discharge_date ? this.order.discharge_date : "";
      // this.orderData.delivery_date = this.order.delivery_date ? this.order.delivery_date : "";
      // this.orderData.payment_date = this.order.payment_date ? this.order.payment_date : "";
      // this.orderData.completion_contract_date = this.order.completion_contract_date ? this.order.completion_contract_date : "";
      // this.orderData.completion_actual_date = this.order.completion_actual_date ? this.order.completion_actual_date : "";
    },
    beforeClose(){
      this.orderData = {
        invoice_number: '',
        discharge_date: '',
        completion_actual_date: '',
      }
    }
  }
}
</script>
<style>
  .date-picker {
    display: block;
    width: 100%;
    padding: 12px;
    border: 1px solid #e8ebf3;
    border-radius: .25rem;
    border-bottom: 1px solid #e8ebf3;
  }
  .date-picker input {
    border: none;
  }
</style>
<style scoped>
  /deep/ .vm--modal {
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 40% !important;
    height: 80% !important;
    margin: auto;
    position: absolute;
    padding-bottom: 20px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>

